"use client";

import { LinkIcon } from "@heroicons/react/24/solid";
import { Button, handleCopyClipboard } from "@saridana-core/react-ui-kit";
import { TCareerItem } from "@shared/types";
import { ButtonLink } from "@shared/ui";
import { FacebookIcon, LinkedinIcon, WhatsappIcon, XIcon } from "@shared/ui/custom-icon";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";

export function CareerFooterSection({ buttons, sharedLink }: TCareerItem) {
  return (
    <section className="bg-white">
      <div className="container relative lg:max-w-[872px] mx-auto">
        {buttons && buttons?.length > 0 && (
          <div className="flex justify-center space-x-3 mx-auto mb-8">
            {buttons?.map((button, index) => (
              <ButtonLink key={"career-footer-button-" + index} {...button} variant={"default"} />
            ))}
          </div>
        )}

        <div className="flex gap-4 items-center justify-center">
          <div className="text-gray-700 text-xl font-semibold">Bagikan:</div>
          <div className="flex items-center gap-3">
            <WhatsappShareButton url={sharedLink || ""}>
              <WhatsappIcon className="size-6 text-gray-700" />
            </WhatsappShareButton>
            <LinkedinShareButton url={sharedLink || ""}>
              <LinkedinIcon className="size-6 text-gray-700" />
            </LinkedinShareButton>
            <TwitterShareButton url={sharedLink || ""}>
              <XIcon className="size-6 text-gray-700" />
            </TwitterShareButton>
            <FacebookShareButton url={sharedLink || ""}>
              <FacebookIcon className="size-6 text-gray-700" />
            </FacebookShareButton>
            <Button size="icon" variant="ghost" className="size-6 !bg-transparent" onClick={() => handleCopyClipboard(sharedLink || "")}>
              <LinkIcon className="size-6 text-gray-700" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
